














import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import VendorListingForm from '@superUI/Forms/VendorListingForm'
import RequestButton from '@components/RequestButton'

settings =
  name: 'VendorListingCreate'
  components: { Back, SuperContainerView, VendorListingForm, RequestButton }

  resources:
    vendor_listing:
      resourceName: 'vendor_listing'
      slug: 'vendor_listings/new'

  vue:
    methods:
      hiSave: -> @saveItem('prime.vendor_listing')
      onSave: (item) -> @$router.back()

export default VueOptions.vue settings
